import './CarCard.css'
import {IModel} from "../model/B2CInfo";
import React, {CSSProperties, useLayoutEffect, useState} from "react";

interface ICarCardProps {
    model: IModel
    withShadow: boolean
    mobile: boolean
}

function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

export default function CarCard(props: ICarCardProps) {
    const [width, height] = useWindowSize();

    if (props.mobile) {
        let style: CSSProperties
        if (props.model.bg_color_bottom != undefined) {
            style = {
                height: `${(167 * width / 375)}px`,
                background: `linear-gradient(142.76deg, ${props.model.bg_color_top} 2.45%, ${props.model.bg_color_bottom} 103.5%), #FFFFFF`
            }
        } else {
            style = {height: `${(167 * width / 375)}px`, backgroundColor: props.model.bg_color_top};
        }
        return <div className="Mobile_car_card_container">
            <div className="Mobile_car_card" style={style}>
                <img src={props.model.icon} className="Mobile_car_card_icon"/>
                <div className="Mobile_car_card_title" style={{color: props.model.title_color}}>{props.model.name}</div>
            </div>
            {props.withShadow && <div className="Car_card_shadow"/>}
        </div>;
    } else {
        let style: CSSProperties
        if (props.model.bg_color_bottom != undefined) {
            style = {
                background: `linear-gradient(142.76deg, ${props.model.bg_color_top} 2.45%, ${props.model.bg_color_bottom} 103.5%), #FFFFFF`
            }
        } else {
            style = {backgroundColor: props.model.bg_color_top};
        }
        return <div className="Car_card_container">
            <div className="Car_card" style={style}>
                <img src={props.model.icon} className="Car_card_icon"/>
                <div className="Car_card_title" style={{color: props.model.title_color}}>{props.model.name}</div>
            </div>
            {props.withShadow && <div className="Car_card_shadow"/>}
        </div>;
    }
}